import { inject, Injectable } from '@angular/core'
import { Action, Store } from '@ngrx/store'

import * as EventTicketPurchasesSelectors from './event-ticket-purchases.selectors'
import { SharedEventTicketPurchasesFacade } from 'libs/shared/models/event-tickets/event-ticket-purchases.models'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

@Injectable({
  providedIn: 'root',
})
export class EventTicketPurchasesFacade implements SharedEventTicketPurchasesFacade, GbBaseFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.select(EventTicketPurchasesSelectors.selectEventTicketPurchasesLoaded)
  allEventTicketPurchases$ = this.store.select(EventTicketPurchasesSelectors.selectAllEventTicketPurchases)
  selectedEventTicketPurchases$ = this.store.select(EventTicketPurchasesSelectors.selectEntity)
  selectedPurchaseId$ = this.store.select(EventTicketPurchasesSelectors.selectSelectedId)
  selectedPurchaseEventTickets$ = this.store.select(EventTicketPurchasesSelectors.selectedPurchaseEventTickets)
  selectedPurchaseCustomQuestions$ = this.store.select(EventTicketPurchasesSelectors.selectedPurchaseCustomQuestions)
  searchHistory$ = this.store.select(EventTicketPurchasesSelectors.selectSearchHistory)
  dataView$ = this.store.select(EventTicketPurchasesSelectors.selectDataView)
  searchTerm$ = this.store.select(EventTicketPurchasesSelectors.selectSearchTerm)
  order$ = this.store.select(EventTicketPurchasesSelectors.selectOrder)
  refunded$ = this.store.select(EventTicketPurchasesSelectors.selectRefunded)
  displayColumns$ = this.store.select(EventTicketPurchasesSelectors.selectDisplayColumns)
  count$ = this.store.select(EventTicketPurchasesSelectors.selectCount)
  placePurchaseLoaded$ = this.store.select(EventTicketPurchasesSelectors.selectPlacePurchaseLoaded)
  profileRegistrationCustomQuestionAnswers$ = this.store.select(
    EventTicketPurchasesSelectors.selectEventTicketPurchaseProfileRegistrationCustomQuestionAnswers,
  )

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
